/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import * as loading from '../../assets/preloading.json';
import { Container } from './styles';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loading.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const Loader = () => (
  <Lottie options={defaultOptions} height={120} width={120} />
);

const PageLoader = () => {
  const [done, setDone] = useState(false);
  const [fading, setFading] = useState(false);

  const fadeOut = () => {
    setFading(true);
    setTimeout(() => {
      setDone(true);
    }, 1000);
  };

  useEffect(() => {
    setTimeout(fadeOut, 500);
  }, [done]);

  return (
    <Container className={`${done && 'done'} ${fading && 'fading'}`}>
      <Loader />
    </Container>
  );
};

export default PageLoader;
